module.exports = __webpack_public_path__ + "img/banner2.674593de.png";